import React from 'react';
import './v2_Loader.css';

/**
 * V2Loader — Animated loading spinner with text.
 * Displays a circular blue spinner with loading message.
 */
function V2Loader({ title = 'Loading', subtitle = 'Please wait while the AI extracts the information' }) {
  return (
    <div className="v2-loader">
      <div className="v2-loader__spinner" aria-hidden="true" />
      <h3 className="v2-loader__title">{title}</h3>
      {subtitle && <p className="v2-loader__subtitle">{subtitle}</p>}
    </div>
  );
}

export default V2Loader;
